// 포인트 상점 아이콘(2026-10-04). 이모지는 기기마다 모양이 다르고, 글꼴이 없는 브라우저(일부 앱 안의
// 브라우저 포함)에서는 네모로 깨진다. 그래서 직접 그린 SVG 를 쓴다. 크기는 글자 크기를 따른다.

export const CoinIcon = ({ size = "1.15em" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" style={{ flexShrink: 0 }}>
    <defs>
      <linearGradient id="reward-coin-face" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#FFE07A" />
        <stop offset="1" stopColor="#F5B400" />
      </linearGradient>
    </defs>
    <circle cx="12" cy="12" r="11" fill="#E09A00" />
    <circle cx="12" cy="11.2" r="10" fill="url(#reward-coin-face)" />
    <circle cx="12" cy="11.2" r="7.4" fill="none" stroke="#E8A300" strokeWidth="1.2" />
    <text x="12" y="15.4" textAnchor="middle" fontSize="11" fontWeight="900" fill="#9A5B00" fontFamily="Arial, sans-serif">
      P
    </text>
  </svg>
);

export const BagIcon = ({ size = "1.1em", color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" style={{ flexShrink: 0 }}>
    <path d="M5 8h14l-1.2 11.2A2 2 0 0 1 15.8 21H8.2a2 2 0 0 1-2-1.8L5 8z" fill={color} />
    <path d="M8.5 10V7a3.5 3.5 0 0 1 7 0v3" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" />
    <circle cx="9" cy="11.5" r="1.1" fill="#00D9C0" />
    <circle cx="15" cy="11.5" r="1.1" fill="#00D9C0" />
  </svg>
);

export const FriendsIcon = ({ size = "1.2em" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" style={{ flexShrink: 0 }}>
    <circle cx="8.5" cy="8" r="3.3" fill="#FF9EB5" />
    <path d="M2.5 19c0-3.4 2.7-6 6-6s6 2.6 6 6" fill="#FF9EB5" />
    <circle cx="16" cy="9" r="3" fill="#00B8A3" />
    <path d="M11 19.5c.3-3 2.4-5.2 5-5.2s4.8 2.2 5 5.2" fill="#00B8A3" />
  </svg>
);

export const TicketIcon = ({ size = "1.1em" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" style={{ flexShrink: 0 }}>
    <path
      d="M3 7a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v2.2a2.8 2.8 0 0 0 0 5.6V17a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-2.2a2.8 2.8 0 0 0 0-5.6V7z"
      fill="#FFB547"
    />
    <path d="M14 6v12" stroke="#fff" strokeWidth="1.4" strokeDasharray="2 2" />
  </svg>
);

export const HistoryIcon = ({ size = "1.1em" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" style={{ flexShrink: 0 }}>
    <rect x="4" y="3" width="16" height="18" rx="3" fill="#7FB2FF" />
    <path d="M8 8h8M8 12h8M8 16h5" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

// 같이 사기 팝업 위에 크게 놓는 그림. 동글동글한 두 친구와 작은 하트.
export const FriendsBadge = ({ size = 92 }) => (
  <svg width={size} height={size * 0.72} viewBox="0 0 120 86" aria-hidden="true">
    <ellipse cx="60" cy="80" rx="44" ry="5" fill="#E6EDEC" />
    {/* 왼쪽 친구 */}
    <circle cx="40" cy="44" r="27" fill="#FFC9D6" stroke="#fff" strokeWidth="4" />
    <path d="M17 36c4-14 15-20 26-19 9 1 17 7 19 16-9-3-16-9-19-13-6 8-15 14-26 16z" fill="#6B4A3A" />
    <circle cx="31" cy="47" r="3" fill="#2B2F36" />
    <circle cx="49" cy="47" r="3" fill="#2B2F36" />
    <circle cx="26" cy="55" r="4" fill="#FF8FAB" opacity="0.6" />
    <circle cx="54" cy="55" r="4" fill="#FF8FAB" opacity="0.6" />
    <path d="M34 55c3 4 9 4 12 0" fill="none" stroke="#2B2F36" strokeWidth="2.4" strokeLinecap="round" />
    {/* 오른쪽 친구 */}
    <circle cx="80" cy="46" r="27" fill="#BFF3EB" stroke="#fff" strokeWidth="4" />
    <path d="M55 40c1-15 13-23 25-23 13 0 24 9 25 22-6-6-13-9-22-9-11 0-20 4-28 10z" fill="#2E3A4A" />
    <circle cx="71" cy="49" r="3" fill="#2B2F36" />
    <circle cx="89" cy="49" r="3" fill="#2B2F36" />
    <circle cx="66" cy="57" r="4" fill="#00B8A3" opacity="0.35" />
    <circle cx="94" cy="57" r="4" fill="#00B8A3" opacity="0.35" />
    <path d="M73 57c3 5 10 5 13 0" fill="none" stroke="#2B2F36" strokeWidth="2.4" strokeLinecap="round" />
    {/* 하트 */}
    <path d="M60 14c-3-6-12-5-12 2 0 6 8 10 12 14 4-4 12-8 12-14 0-7-9-8-12-2z" fill="#FF4D79" stroke="#fff" strokeWidth="2.5" />
  </svg>
);

// 수학 풀이 사진 보너스 창(2026-10-06). 사진기 + 반짝이 + 동전
export const PhotoBonusBadge = ({ size = 104 }) => (
  <svg width={size} height={size * 0.78} viewBox="0 0 128 100" aria-hidden="true">
    <ellipse cx="62" cy="94" rx="42" ry="5" fill="#E6EDEC" />
    {/* 사진기 */}
    <rect x="18" y="30" width="86" height="58" rx="14" fill="#BFF3EB" stroke="#fff" strokeWidth="4" />
    <path d="M44 30l7-11h22l7 11z" fill="#8FE3D6" stroke="#fff" strokeWidth="3" strokeLinejoin="round" />
    <circle cx="61" cy="59" r="19" fill="#fff" />
    <circle cx="61" cy="59" r="13" fill="#2E3A4A" />
    <circle cx="56" cy="54" r="4" fill="#fff" opacity="0.85" />
    <rect x="86" y="38" width="10" height="6" rx="3" fill="#FF8FAB" />
    {/* 반짝이 */}
    <path d="M12 16l2.5 6 6 2.5-6 2.5-2.5 6-2.5-6-6-2.5 6-2.5z" fill="#FFD25A" />
    <path d="M108 12l1.8 4.2 4.2 1.8-4.2 1.8-1.8 4.2-1.8-4.2-4.2-1.8 4.2-1.8z" fill="#FF8FAB" />
    {/* 동전 */}
    <circle cx="104" cy="72" r="17" fill="#E09A00" />
    <circle cx="104" cy="70.6" r="15.4" fill="#FFD25A" />
    <circle cx="104" cy="70.6" r="11" fill="none" stroke="#E8A300" strokeWidth="1.8" />
    <text x="104" y="76.4" textAnchor="middle" fontSize="16" fontWeight="900" fill="#9A5B00" fontFamily="Arial, sans-serif">
      P
    </text>
  </svg>
);
